import { render, staticRenderFns } from "./EdButton.vue?vue&type=template&id=70d00f93&"
import script from "./EdButton.vue?vue&type=script&lang=js&"
export * from "./EdButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports